import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { CheckFinding, CheckFindingSeverity } from "../../../models/InvoiceBatch";
import { translateDryRunFinding } from "../../../utils/invoiceDryRun.messages";

const SEVERITY_CLASSES: Record<CheckFindingSeverity, string> = {
	error: "border-red-200 bg-red-50 text-red-700",
	warning: "border-amber-300 bg-amber-50 text-amber-800",
};

export const DryRunSeverityChip: React.FC<{ severity: CheckFindingSeverity }> = ({ severity }) => {
	const { t } = useTranslation();

	return (
		<span
			className={cn(
				"inline-flex w-fit shrink-0 items-center whitespace-nowrap rounded-full border border-solid px-2 py-0.5 text-xs font-medium",
				SEVERITY_CLASSES[severity]
			)}
		>
			{t(`invoiceBatch.dryRun.severity.${severity}` as any)}
		</span>
	);
};

interface Props {
	finding: CheckFinding;
	/** Shown before the text, e.g. the customer of a batch-level finding. */
	context?: string;
}

/** One dry-run finding: severity chip and the translated text. */
const InvoiceDryRunFindingRow: React.FC<Props> = ({ finding, context }) => {
	const { t, i18n } = useTranslation();

	return (
		<li className="flex items-start gap-2 py-1">
			<DryRunSeverityChip severity={finding.severity} />
			<span className="whitespace-normal break-words text-sm text-gray-800">
				{context && <span className="font-medium">{context}: </span>}
				{translateDryRunFinding(finding, i18n.language)}
				{finding.tenantId && (
					<span className="ml-1 text-xs text-gray-500">
						({t("invoiceBatch.dryRun.tenant", { tenantId: finding.tenantId })})
					</span>
				)}
			</span>
		</li>
	);
};

export default InvoiceDryRunFindingRow;
